export default __webpack_public_path__ + "static/consumer-awards-webby-honoree-8c76530b978f57f285ffe7c07175533d.png";